export const getResellersColumns = (t) => [
  {
    field: 'name',
    headerName: t('Reseller name'),
    flex: 1.3,
    minWidth: 280,
    sortable: true,
  },
  {
    field: 'email',
    headerName: t('Email'),
    flex: 1.1,
    minWidth: 260,
    sortable: false,
  },
  {
    field: 'phone',
    headerName: t('Phone'),
    flex: 1,
    minWidth: 220,
    sortable: false,
  },
  {
    field: 'contactPersonFullName',
    headerName: t('Contact person'),
    flex: 1.1,
    minWidth: 260,
    sortable: false,
  },
];
